import { EyeOff } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const EyeOffIcon = DeckardIconWrapper({ Icon: EyeOff });
